<template lang="pug">
  .projects.page    
    main.content
      .row
        .txt.txtCenter.col-8.col-offset-2.col-m-12.col-m-offset-0
          p {{ projects.content.main }}
      #jobs.row
        .job.col-4.col-tp-6.col-m-12(v-for="item of projects.content.items")
          .logo
            component(v-if="item.logo.type === 'svg'", v-bind:is="item.logo.image")
            img(v-else, :src="item.logo.image")
          .info(:style="{ background: item.color }")
            h4.title {{ item.job }}
            ul
              li(v-for="tag of item.tags") {{ tag }}
            a(v-if="item.link", :href="item.link", target="_blank").bt Ver projeto
            .fakeBt(v-else)
    NavFooter(v-bind:nav="projects.navFooter")
</template>

<script>
import './style.sass'
import {mapState} from 'vuex'
import Cover from '@/components/Cover/index.vue'
import NavFooter from '@/components/NavFooter/index.vue'

export default {
  name: 'Projects',
  components: {
    Cover,
    NavFooter
  },
  computed: {
    ...mapState({
      projects: state => state.projects
    })
  },
  mounted () {
    this.$store.commit('setLoading', false)
  }
}
</script>